"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const v0 = (0, utils_1.buildTypes)({
    max: 9,
    types: {
        AccountInfo: "AccountInfoWithRefCountU8"
    }
});
const v1 = (0, utils_1.buildTypes)({
    min: 10,
    max: 12,
    types: {
        AccountInfo: "AccountInfoWithRefCount"
    }
});
const v2 = (0, utils_1.buildTypes)({
    min: 13,
    max: 14,
    types: {
        AccountInfo: "AccountInfoWithDualRefCount"
    }
});
const v3 = (0, utils_1.buildTypes)({
    min: 15,
    types: {
        AccountInfo: "AccountInfoWithTripleRefCount"
    }
});
exports.default = [v0, v1, v2, v3];
